import { DocumentFieldAPIModel } from '~/api/def/endpoints/document';
import { PlainTable } from '~/components/ui/tables/bq/PlainTable';
import { useEffect, useState } from 'react';

export type FieldListProps = {
  documentFields: DocumentFieldAPIModel[];
};
export const FieldList = ({ documentFields }: FieldListProps) => {
  const [columns, setColumns] = useState<string[]>([]);
  const [rows, setRows] = useState<string[][]>([]);

  useEffect(() => {
    if (documentFields.length > 0) {
      const cols: string[] = [];
      const cRows: string[][] = [];
      const cRow: string[] = [];
      documentFields.forEach((field) => {
        cols.push(field.name);
        cRow.push(field.value);
      });
      cRows.push(cRow);
      setColumns(cols);
      setRows(cRows);
    }
  }, [documentFields]);
  if (columns.length > 0)
    return (
      <div className="field-list-container">
        <PlainTable columns={columns} data={rows} classes="field-list-table" />
      </div>
    );
  return (
    <div className="fields">
      <span>No extracted fields found</span>
    </div>
  );
};
